import { shiftRegYm } from "./settlementFormat.js";

/** compare API와 동일한 Δ% 계산 */
function deltaPct(cur, prev) {
    const c = Number(cur);
    const p = Number(prev);
    if (prev == null || prev === undefined || isNaN(p) || p === 0) return null;
    return parseFloat((((c - p) / p) * 100).toFixed(1));
}

function blockFromFooter(matrix) {
    if (!matrix?.footer) return { dataAvailable: false };
    return {
        dataAvailable: true,
        usageQty: matrix.footer.usageQty,
        totalAmount: matrix.footer.totalAmount,
        kepcoTotalAmount: matrix.footer.kepcoTotalAmount,
        billingAvailable: matrix.status === "FINAL",
    };
}

function withDeltas(current, block) {
    if (!block.dataAvailable || !current.dataAvailable) return block;
    return {
        ...block,
        usageDeltaPct: deltaPct(current.usageQty, block.usageQty),
        amountDeltaPct:
            current.billingAvailable && block.billingAvailable
                ? deltaPct(current.totalAmount, block.totalAmount)
                : null,
    };
}

/** 단지 합계 compare — matrix·prevMatrix·history(전년)로 클라이언트 합성 */
export function buildSiteCompare({ matrix, prevMatrix, historyRows, regYm }) {
    const current = blockFromFooter(matrix);
    if (!current.dataAvailable) {
        return {
            regYm,
            current,
            compare: { prevMonth: { dataAvailable: false }, prevYearSameMonth: { dataAvailable: false } },
        };
    }

    const prevMonthRaw = blockFromFooter(prevMatrix);
    const prevYearYm = shiftRegYm(regYm, -12);
    const hist = (historyRows || []).find((h) => String(h.regYm) === prevYearYm && h.status === "FINAL");
    const prevYearRaw = hist
        ? {
              dataAvailable: true,
              usageQty: parseFloat(hist.masterUsageQty ?? hist.usageQtySum ?? 0),
              totalAmount: parseFloat(hist.totalAmountSum ?? 0),
              billingAvailable: true,
          }
        : { dataAvailable: false };

    return {
        regYm,
        current,
        compare: {
            prevMonth: withDeltas(current, prevMonthRaw),
            prevYearSameMonth: withDeltas(current, prevYearRaw),
        },
    };
}
